import { render, staticRenderFns } from "./traingReply.vue?vue&type=template&id=de501b42"
import script from "./traingReply.vue?vue&type=script&lang=js"
export * from "./traingReply.vue?vue&type=script&lang=js"
import style0 from "./traingReply.vue?vue&type=style&index=0&id=de501b42&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports